import { config } from '@repo/common-types';

export const getBlockExplorerUrl = (chain: string, txId: string | null) => {
  if (!txId) {
    return '';
  }
  switch (chain) {
    case 'polygon':
      return `${config.deposits.polygon.blockExplorerUrl}/tx/${txId}`;
    case 'bitcoin':
      return `https://btcscan.org/tx/${txId}`;
    case 'solana':
      return `https://solscan.io/tx/${txId}`;
    case 'base':
      return `https://basescan.org/tx/${txId}`;
    case 'arbitrum':
      return `https://arbiscan.io/tx/${txId}`;
    case 'optimism':
      return `https://optimistic.etherscan.io/tx/${txId}`;
    case 'avalanche':
      return `https://snowtrace.io/tx/${txId}`;
    case 'bnb':
    case 'binance-smart-chain':
      return `https://bscscan.com/tx/${txId}`;
    case 'ethereum':
      return `https://etherscan.io/tx/${txId}`;

    default:
      return `${config.deposits.polygon.blockExplorerUrl}/tx/${txId}`;
  }
};
